import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取城市列表
export const getbuildList = params => {
    return get(`/admin/building`, params);
};
// 新增城市
export const addBuild = params => {
    return post("/admin/building", params);
};
// 修改城市信息
export const editBuild = params => {
    return put(`/admin/building/${params.id}`, params);
};
// 删除城市
export const deleteBuild = params => {
    return del(`/admin/building/${params}`);
};
// 生成二维码
export const getImg = params => {
    return post("/admin/building/qrcode", params);
};


// WEBPACK FOOTER //
// ./src/api/building.js